import { render, staticRenderFns } from "./ImportExportEmailServer.vue?vue&type=template&id=113f4e86"
import script from "./ImportExportEmailServer.vue?vue&type=script&lang=js"
export * from "./ImportExportEmailServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports